<template>
  <v-layout>
    <v-flex class="px-10 py-5">
      <v-data-table
        :headers="headers"
        :items="historial"
        :loading="loader"
        loading-text="Listando Datos..."
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-container class="px-5 py-4">
            <v-layout>
              <h2 class="py-2 pl-3">Historial de Envios de Guardia (FUTURO)</h2>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row class="mt-6 mb-4">
              <v-flex xs12 sm12 md3 class="px-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex xs12 sm12 md2 class="px-2">
                <v-text-field
                  v-model="fechaInicio"
                  type="date"
                  hide-details
                  label="Inicio"
                  :max="new Date().toISOString().substr(0, 10)"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md2 class="px-2">
                <v-text-field
                  v-model="fechaFin"
                  type="date"
                  hide-details
                  label="Fin"
                  :max="new Date().toISOString().substr(0, 10)"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
                <v-btn color="blue" dark @click="listarHistorial" block>
                  Listar
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
                <v-btn
                  color="green"
                  :block="$vuetify.breakpoint.smAndDown"
                  dark
                  @click="formatReporte"
                >
                  <v-icon class="ml-2">fas fa-file-excel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario.toLocaleUpperCase() }}
        </template>

        <template v-slot:[`item.fechaEnvio`]="{ item }">
          {{ formatDate(item.fechaEnvio) }}
        </template>
        <template v-slot:[`item.horaEnvio`]="{ item }"
          >{{ formatTime(item.fechaEnvio) }}
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import XLSX from "xlsx";

export default {
  data() {
    return {
      text: "Historial Gruas",
      search: "",
      isEntrega: false,
      loader: false,
      loading4: false,
      dialog: false,
      selectedHistorial: null,
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      historial: [],
      headers: [
        {
          text: "Usuario",
          value: "usuario",
          sortable: true,
          align: "center",
          width: 250,
        },
        {
          text: "Numero de Lote",
          value: "nlote",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Tipo Guardia",
          value: "tipoGuardia",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Fecha Envio",
          value: "fechaEnvio",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Hora Envio",
          value: "horaEnvio",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Asistencias No Guardadas",
          value: "asistenciasErrores",
          sortable: true,
          align: "center",
          width: 120,
        },
      ],
    };
  },
  created() {
    const today = new Date();
    const firstDayInMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 5
    );
    this.fechaInicio = firstDayInMonth.toISOString().substring(0, 10);

    this.listarHistorial();
  },
  computed: {},
  methods: {
    limpiar() {
      this.selectedHistorial = null;
      this.dialog = false;
    },
    ExportarExcel(listado) {
      let data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();
      const filename = `Historial Guardia Futuro ${this.fechaInicio.toString(
        "yyyy-MM-dd"
      )} a ${this.fechaFin.toString("yyyy-MM-dd")}`;

      data["!cols"] = [
        { wch: 30 },
        { wch: 20 },
        { wch: 30 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 12 },
        { wch: 11 },
        { wch: 9 },
      ];
      XLSX.utils.book_append_sheet(workbook, data, "Historial");
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    formatReporte() {
      const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toISOString().split("T")[0];
      };

      const listadoHistorial = this.historial.map((data) => {
        const historial = {
          Usuario: data.usuario.toLocaleUpperCase(),
          "Número de Lote": data.nlote,
          "Fecha Envio": formatDate(data.fechaEnvio),
          "Hora Envio": this.formatTime(data.fechaEnvio),
          "Tipo Guardia": data.tipoGuardia,
        };

        delete historial.usuarioId;
        return historial;
      });

      this.ExportarExcel(listadoHistorial);
    },
    listarHistorial() {
      this.loader = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/HistorialGuardia?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
          configuracion
        )
        .then((res) => {
          this.historial = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    formatDate(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      return moment(fecha).format("YYYY-MM-DD");
    },
    formatTime(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      return moment(fecha).format("HH:mm:ss");
    },
  },
};
</script>
